export const SET_FILTER_GEOJSON = "SET_FILTER_GEOJSON";
export const SET_META_MAP = "SET_META_MAP";
export const SET_GEOJSON_DATA = "SET_GEOJSON_DATA";
export const SET_LOADING_MAP = "SET_LOADING_MAP";
export const SET_LAYER_INFO = "SET_LAYER_INFO";
export const SET_OPEN_BOTTOM_BAR = "SET_OPEN_BOTTOM_BAR";
export const SET_ACTIVE_KEY_SIDEBAR = "SET_ACTIVE_KEY_SIDEBAR";
export const UPDATE_GEOJSON_DATA = "UPDATE_GEOJSON_DATA";
export const SET_MAP_URL = "SET_MAP_URL";
